// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"15484c24","408":"77993178","976":"8777876a"}[chunkId] + ".chunk.js";
};